import { useNavigate } from "react-router";
import { useAppDispatch } from "../../redux/useAppDispatch";
import { lockAudio } from "../../redux/Transcribe/TranscribeAction";

interface NameLinkProps<T> {
  name: string;
  navigateTo: string;
  isopenModal?: boolean;
  disabled?: boolean;
  record: any;
  type?: string;
}

function NameLink<T>(props: NameLinkProps<T>) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const Namelink = () => {
    if (props.disabled) {
      return;
    }
    if (props.type !== "organization") {
      dispatch(lockAudio(props.record.packId));
    }

    navigate(props.navigateTo);
  };

  return (
    <div
      className={`${props.disabled ? "" : "link"}`}
      onClick={Namelink}>
      {props.name}
    </div>
  );
}

export default NameLink;
